// extracted by mini-css-extract-plugin
export var addButton = "_jk-0";
export var border = "_jk-8";
export var check = "_jk-h";
export var danger = "_jk-6";
export var dropdownContainer = "_jk-1";
export var editModalBody = "_jk-j";
export var footerContainer = "_jk-i";
export var fullWidth = "_jk-a";
export var hide = "_jk-9";
export var icon = "_jk-3";
export var input = "_jk-7";
export var inputFlex = "_jk-b";
export var inputWrapper = "_jk-c";
export var manualFocus = "_jk-5";
export var optionButton = "_jk-4";
export var pillWrapper = "_jk-e";
export var pointer = "_jk-2";
export var showOverflow = "_jk-f";
export var tagsFlex = "_jk-d";
export var xButton = "_jk-g";